export default __webpack_public_path__ + "static/media/arrow.17133b8f.svg";